'use strict';

(function app($) {
  var tabletBreak = 1260;
  var mobileBreak = 768;
  var mobileXSBreak = 375;
  var pageOffsetX = window.scrollX;
  var pageOffsetY = window.scrollY;
  var frozeException = null;
  var isWindowFrozen = false;
  var menuOpen = false;
  var offsetY = window.pageYOffset;

  // Base functions

  function detectBrowser() {
    var html = $('html');
    function init() {
      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf('chrome') > -1 && userAgent.indexOf('edg/') <= -1) {
        html.addClass('sbn-is-chrome');
      } else {
        html.removeClass('sbn-is-chrome');
      }
      if (
        userAgent.indexOf('safari') > -1
        && userAgent.indexOf('chrome') <= -1
      ) {
        html.addClass('sbn-is-safari');
      } else {
        html.removeClass('sbn-is-safari');
      }
      if (userAgent.indexOf('firefox') > -1) {
        html.addClass('sbn-is-firefox');
      } else {
        html.removeClass('sbn-is-firefox');
      }
      if (
        userAgent.indexOf('msie ') > -1
        || userAgent.indexOf('trident/') > -1
      ) {
        html.addClass('sbn-is-ie');
      } else {
        html.removeClass('sbn-is-ie');
      }
      if (userAgent.indexOf('edg/') > -1) {
        html.addClass('sbn-is-edge');
      } else {
        html.removeClass('sbn-is-edge');
      }
    }
    $('html head meta[name="viewport"]').attr(
      'content',
      'width=device-width, initial-scale=1, shrink-to-fit=no, user-scalable=0'
    );
    $(window).on('load resize', function onLoad() {
      init();
    });
    init();
  }

  function detectDevice() {
    var html = $('html');
    function init() {
      var viewport = $('html head meta[name="viewport"]')[0];
      var userAgent = navigator.userAgent.toLowerCase();
      var orientation = window.matchMedia('(orientation: portrait)').matches;

      // System
      if (userAgent.indexOf('mac') > -1) {
        html.addClass('sbn-is-mac sbn-is-macos');
      } else {
        html.removeClass('sbn-is-mac sbn-is-macos');
      }
      if (userAgent.match(/(iphone|ipod|ipad)/)) {
        if (userAgent.match(/iphone/)) {
          if (window.screen.width < mobileBreak && window.screen.width >= 390) {
            html.addClass('sbn-is-iphone-12');
          } else {
            html.removeClass('sbn-is-iphone-12');
          }
          if (window.screen.width < mobileBreak && window.screen.width < 390) {
            html.addClass('sbn-is-iphone-10');
          } else {
            html.removeClass('sbn-is-iphone-10');
          }
          if (window.screen.width < mobileBreak && window.screen.width < 375) {
            html.addClass('sbn-is-iphone-5');
          } else {
            html.removeClass('sbn-is-iphone-5');
          }
          html.addClass('sbn-is-iphone');
        } else {
          html.removeClass(
            'sbn-is-iphone-12 sbn-is-iphone-10 sbn-is-iphone-5 sbn-is-iphone'
          );
        }
        if (userAgent.match(/ipod/)) {
          html.addClass('sbn-is-ipod');
        } else {
          html.removeClass('sbn-is-ipod');
        }
        if (userAgent.match(/ipad/)) {
          html.addClass('sbn-is-ipad');
        } else {
          html.removeClass('sbn-is-ipad');
        }
        html.addClass('sbn-is-ios');
      } else {
        html.removeClass('sbn-is-phone sbn-is-ipod sbn-is-ipad sbn-is-ios');
      }
      if (userAgent.indexOf('android') > -1) {
        html.addClass('sbn-is-android');
      } else {
        html.removeClass('sbn-is-android');
      }

      // Type
      if (
        navigator.maxTouchPoints === 1
        && userAgent.indexOf('Mobile') === -1
      ) {
        $('html').addClass('sbn-is-emulation');
      } else {
        $('html').removeClass('sbn-is-emulation');
      }
      if (
        (html.hasClass('sbn-is-mac')
          || html.hasClass('sbn-is-ios')
          || html.hasClass('sbn-is-android'))
        && navigator.maxTouchPoints
        && navigator.maxTouchPoints >= 1
      ) {
        $('html').addClass('sbn-is-touchable');
      } else {
        $('html').removeClass('sbn-is-touchable');
      }

      // Media
      if ($(window).width() < mobileBreak) {
        if (window.screen.width < mobileXSBreak) {
          viewport.setAttribute(
            'content',
            'width=' + mobileXSBreak + ', user-scalable=0'
          );
        } else {
          viewport.setAttribute(
            'content',
            'width=device-width, initial-scale=1'
          );
        }
        $('html').removeClass('sbn-is-desktop sbn-is-tablet');
        $('html').addClass('sbn-is-mobile');
      } else {
        $('html').addClass('sbn-is-desktop');
        if (
          (window.screen.width >= mobileBreak
            && window.screen.width <= tabletBreak)
          || (window.screen.width < mobileBreak
            && window.screen.height >= mobileBreak
            && !orientation)
        ) {
          $('html').addClass('sbn-is-tablet');
          viewport.setAttribute(
            'content',
            'width=' + tabletBreak + ', user-scalable=0'
          );
        } else {
          $('html').removeClass('sbn-is-tablet');
          viewport.setAttribute(
            'content',
            'width=device-width, initial-scale=1, shrink-to-fit=no, user-scalable=0'
          );
        }
        $('html').removeClass('sbn-is-mobile');
      }
    }
    $(window).on('load resize', function onLoad() {
      init();
    });
    init();
  }

  // Helper functions

  function isMobile() {
    return window.innerWidth <= mobileBreak - 0.02;
  }

  function isTouchable() {
    return $('html').hasClass('sbn-is-touchable');
  }

  function isOutside(event, target) {
    var container = $(target);
    if (
      !container.is(event.target)
      && container.has(event.target).length === 0
    ) {
      return true;
    }
    return false;
  }

  function scrollFix(target) {
    var windowScrollLeft = $(window).scrollLeft();
    if (windowScrollLeft > 0 && $(target).css('position') === 'fixed') {
      $(target).css('left', -windowScrollLeft + 'px');
    } else {
      $(target).css('left', 0);
    }
  }

  function frozeWindow(isFrozen, exception) {
    var classFrozenWindows = 'sbn-is-frozen-windows';
    var classFrozenOS = 'sbn-is-frozen-os';
    function freezeWindows() {
      if (isFrozen) {
        pageOffsetY = $(window).scrollTop();
        $('body').css({ top: -pageOffsetY + 'px', left: -pageOffsetX + 'px' });
        $('html').addClass(classFrozenWindows);
        isWindowFrozen = true;
      } else {
        isWindowFrozen = false;
        $('html').removeClass(classFrozenWindows);
        $('body').css({ top: 'auto', left: 'auto' });
        $(window).scrollLeft(pageOffsetX);
        $(window).scrollTop(pageOffsetY);
      }
    }
    function freezeOS() {
      if (isFrozen) {
        $('html').addClass(classFrozenOS);
        isWindowFrozen = true;
        if (exception.length) {
          frozeException = exception;
        } else {
          frozeException = null;
        }
        if (
          !$('html').attr('data-froze-state')
          || $('html').attr('data-froze-state') !== 'ready'
        ) {
          document.body.addEventListener(
            'touchmove',
            function onTouch(event) {
              if (isWindowFrozen) {
                if (
                  frozeException !== null
                  && frozeException.length
                  && isOutside(event, frozeException)
                ) {
                  event.preventDefault();
                } else if (frozeException === null) {
                  event.preventDefault();
                }
              }
            },
            { passive: false }
          );
          $('html').attr('data-froze-state', 'ready');
        }
      } else {
        isWindowFrozen = false;
        $('html').removeClass(classFrozenOS);
      }
    }
    if (isFrozen) {
      if ($('html').hasClass('sbn-is-desktop') && !isTouchable()) {
        freezeWindows();
      } else {
        freezeOS();
      }
    } else if (!isFrozen && $('html').hasClass(classFrozenWindows)) {
      freezeWindows();
    } else if (!isFrozen && $('html').hasClass(classFrozenOS)) {
      freezeOS();
    }
  }

  // Advance functions

  function headerCommon() {
    var classReady = 'sbn-is-ready';
    var classVisible = 'sbn-is-visible';
    var header = $('header');
    var headerWrapperMain = header.find('[data-header-role="wrapper-main"]');
    var headerWrapperMainTemporary = headerWrapperMain.clone();
    var headerWrapperMainTemporaryHeading = headerWrapperMainTemporary.find('h1');
    var headerWrapperClone = header.find('[data-header-role="wrapper-clone"]');
    function setScrolling() {
      var scrollPositionTop = $(window).scrollTop();
      var limitEnd = headerWrapperMain.height() * 3;
      if (scrollPositionTop > limitEnd) {
        header.addClass(classVisible);
      } else {
        header.removeClass(classVisible);
      }
    }
    if (!$('header').length) return;
    headerWrapperMainTemporary
      .find('[data-header-settings="unclonable"]')
      .remove();
    headerWrapperMainTemporaryHeading.replaceWith(
      $(
        '<div class="'
          + headerWrapperMainTemporaryHeading.attr('class')
          + '">'
          + headerWrapperMainTemporaryHeading.html()
          + '</div>'
      )
    );
    headerWrapperClone.html(headerWrapperMainTemporary);
    $(window).on('load scroll', function onLoad() {
      header.addClass(classReady);
      setScrolling();
    });
    $(window).on('resize', function onLoad() {
      header.removeClass(classReady);
      setScrolling();
    });
  }

  function accordionAnchor() {
    var classReady = 'sbn-is-ready';
    var classActive = 'sbn-is-active';
    if (!$('.sbn-js-accordion-anchor').length) return;
    $('.sbn-js-accordion-anchor[data-accordion-role="target"]').each(
      function onEach() {
        var accordionTarget = $(this);
        var accordionID = accordionTarget.attr('data-accordion-id');
        var accordionToggle = $(
          '.sbn-js-accordion-anchor[data-accordion-role="toggle"][data-accordion-id="'
            + accordionID
            + '"]'
        );
        accordionToggle.on('click', function onClick(event) {
          var toggle = $(this);
          var toggleType = toggle.attr('data-accordion-type');
          var toggleIcon;
          function setLayout() {
            if (!toggle.hasClass(classActive)) {
              accordionTarget.show();
              accordionTarget.addClass(classActive);
              toggle.addClass(classActive);
            } else {
              accordionTarget.hide();
              accordionTarget.removeClass(classActive);
              toggle.removeClass(classActive);
            }
          }
          if (toggleType === 'link') {
            toggleIcon = toggle.find('[data-accordion-role="toggle-icon"]');
            if (!isOutside(event, toggleIcon)) {
              setLayout();
            }
          } else {
            setLayout();
          }
        });
        $(
          '.sbn-js-accordion-anchor:not(.'
            + classActive
            + ')[data-accordion-role="target"]'
        ).hide();
        accordionToggle.addClass(classReady);
        accordionTarget.addClass(classReady);
      }
    );
  }

  function accordionExpand() {
    var classActive = 'sbn-is-active';
    if (!$('.sbn-js-accordion-expand').length) return;
    $('.sbn-js-accordion-expand').each(function onEach() {
      var accordion = $(this);
      var accordionToggle = accordion.find('[data-accordion-role="toggle"]');
      var accordionTarget = accordion.find('[data-accordion-role="target"]');
      accordionToggle.on('click', function onClick() {
        var accordionHeightMin = parseFloat(accordionTarget.css('min-height'));
        var accordionHeightFull = accordionTarget
          .children()
          .eq(0)
          .outerHeight();
        if (!accordionToggle.hasClass(classActive)) {
          accordionTarget
            .addClass(classActive)
            .animate(
              { height: accordionHeightFull + 'px' },
              500,
              function callback() {
                $(this).css('height', 'auto');
              }
            );
          accordionToggle.addClass(classActive);
          accordion.addClass(classActive);
        } else {
          accordionTarget
            .removeClass(classActive)
            .animate(
              { height: accordionHeightMin + 'px' },
              500,
              function callback() {
                $(this).removeAttr('style');
              }
            );
          accordionToggle.removeClass(classActive);
          accordion.removeClass(classActive);
        }
      });
    });
  }

  function accordionRelate() {
    var classReady = 'sbn-is-ready';
    var classActive = 'sbn-is-active';
    if (!$('.sbn-js-accordion-relate').length) return;
    $('.sbn-js-accordion-relate[data-accordion-role="toggle"]').each(
      function onEach() {
        var accordionToggleLocal = $(this);
        var accordionIDGroup = accordionToggleLocal.attr(
          'data-accordion-id-group'
        );
        var accordionIDLocal = accordionToggleLocal.attr(
          'data-accordion-id-local'
        );
        var accordionToggleGroup = $(
          '.sbn-js-accordion-relate[data-accordion-role="toggle"][data-accordion-id-group="'
            + accordionIDGroup
            + '"]'
        );
        var accordionTargetGroup = $(
          '.sbn-js-accordion-relate[data-accordion-role="target"][data-accordion-id-group="'
            + accordionIDGroup
            + '"]'
        );
        var accordionTargetLocal = $(
          '.sbn-js-accordion-relate[data-accordion-role="target"][data-accordion-id-group="'
            + accordionIDGroup
            + '"][data-accordion-id-local="'
            + accordionIDLocal
            + '"]'
        );
        accordionToggleLocal.on('click', function onClick() {
          if (!accordionToggleLocal.hasClass(classActive)) {
            accordionToggleGroup.removeClass(classActive);
            accordionTargetGroup.removeClass(classActive);
            accordionToggleLocal.addClass(classActive);
            accordionTargetLocal.addClass(classActive);
          } else {
            accordionToggleGroup.removeClass(classActive);
            accordionTargetGroup.removeClass(classActive);
          }
        });
        accordionToggleGroup.addClass(classReady);
        accordionTargetGroup.addClass(classReady);
      }
    );
  }

  function accordionFooter() {
    $(window).on('resize load', function onWindowResize() {
      if (isMobile()) {
        $('.sbn-js-button-dropdown')
          .off('click')
          .on('click', function onClickAccordion() {
            $(this).parents('.has-sub').toggleClass('sbn-is-active');
            $(this).parents('.has-sub').find('.sbn-js-accordion').slideToggle();
            return false;
          });
      }
    });
  }

  function accordionDefault() {
    $('.sbn-js-accordion')
      .find('.sbn-js-accordion-heading')
      .on('click', function onClickHeading() {
        $(this).parent().stop().toggleClass('sbn-is-active');
        $(this)
          .parent()
          .find('.sbn-js-accordion-content')
          .stop()
          .eq(0)
          .slideToggle(500);
      });
  }

  function scrollbarSync() {
    var classReady = 'sbn-is-ready';
    if (!$('.sbn-js-scrollbar-sync').length) return;
    $('.sbn-js-scrollbar-sync[data-scrollbar-role="placeholder"]').each(
      function onEach() {
        var scrollbarPlaceholder = $(this);
        var scrollbarID = scrollbarPlaceholder.attr('data-scrollbar-id');
        var scrollbarPlaceholderWrapper = scrollbarPlaceholder.children().eq(0);
        var scrollbarTarget = $(
          '.sbn-js-scrollbar-sync[data-scrollbar-role="target"][data-scrollbar-id="'
            + scrollbarID
            + '"]'
        );
        var scrollbarTargetWrapper = scrollbarTarget.children().eq(0);
        var isPlaceholderScrolling = false;
        var isTargetScrolling = false;
        var scrollTimer;
        function calculatingWidth() {
          var targetWidth = scrollbarTarget.innerWidth();
          var targetWrapperWidth = scrollbarTargetWrapper.outerWidth();
          var result = (targetWrapperWidth / targetWidth) * 100;
          scrollbarPlaceholderWrapper.css('width', result + '%');
        }
        function calculatingPosition(target, placeholder) {
          var placeholderScrollLeft = placeholder.scrollLeft();
          var placeholderScrollLeftMax = placeholder[0].scrollWidth - placeholder[0].clientWidth;
          var targetScrollLeftMax = target[0].scrollWidth - target[0].clientWidth;
          var result = placeholderScrollLeft
            * (targetScrollLeftMax / placeholderScrollLeftMax);
          return result;
        }
        $(window).on('load resize', function onResize() {
          calculatingWidth();
        });
        scrollbarPlaceholder.on('scroll', function onScroll() {
          if (!isTouchable()) {
            if (!isTargetScrolling) {
              isPlaceholderScrolling = true;
              $(scrollbarTarget).scrollLeft(
                calculatingPosition(scrollbarTarget, scrollbarPlaceholder)
              );
              calculatingWidth();
              clearTimeout(scrollTimer);
              scrollTimer = setTimeout(function onTimeout() {
                isPlaceholderScrolling = false;
              }, 200);
            }
          }
        });
        scrollbarTarget.on('scroll', function onScroll() {
          if (!isPlaceholderScrolling) {
            isTargetScrolling = true;
            $(scrollbarPlaceholder).scrollLeft(
              calculatingPosition(scrollbarPlaceholder, scrollbarTarget)
            );
            calculatingWidth();
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(function onTimeout() {
              isTargetScrolling = false;
            }, 200);
          }
        });
        calculatingWidth();
        scrollbarPlaceholder.addClass(classReady);
        scrollbarTarget.addClass(classReady);
      }
    );
  }

  function scrollLeft() {
    if (!$('.sbn-js-scroll-left').length) return;
    $(window).on('load scroll resize', function onLoad() {
      var winLeft = $(window).scrollLeft();
      $('.sbn-js-scroll-left').css('left', -winLeft + 'px');
    });
  }

  function selecting() {
    var classActive = 'sbn-is-active';
    if (!$('.sbn-js-selecting').length) return;
    $('.sbn-js-selecting').each(function onEach() {
      var target = $(this);
      var toggle = target.find('[data-selecting-role="toggle"]');
      toggle.on('click', function onClick() {
        toggle.toggleClass(classActive);
        target.toggleClass(classActive);
      });
    });
  }

  function prefectureSelect() {
    $('.js-select-box select').on('click change', function onClickChange() {
      var select = $(this);
      if (select.val() !== '') {
        select.addClass('sbn-is-selected');
      } else {
        select.removeClass('sbn-is-selected');
      }
    });
  }

  function lightboxAnchorCloseAll() {
    var classReady = 'sbn-is-ready';
    var classActive = 'sbn-is-active';
    var classGlobalActive = 'sbn-is-lightbox-active';
    $('html').removeClass(classGlobalActive);
    $('.sbn-js-lightbox-anchor').addClass(classReady).removeClass(classActive);
    if (isWindowFrozen) {
      frozeWindow(false);
    }
  }

  function lightboxTogglingCloseAll() {
    var classReady = 'sbn-is-ready';
    var classActive = 'sbn-is-active';
    var classGlobalActive = 'sbn-is-lightbox-active';
    $('html').removeClass(classGlobalActive);
    $('.sbn-js-lightbox-toggling')
      .addClass(classReady)
      .removeClass(classActive);
    lightboxAnchorCloseAll();
    if (isWindowFrozen) {
      frozeWindow(false);
    }
  }

  function smoothScroll() {
    var anchors = $('a[href*="#"]:not([href="#"])');
    var speed = 500;
    var delay = 0;
    var timeout = 0;
    function getPosition(target) {
      var position = $(target).offset().top;
      var positionOffset = !isMobile()
        ? $('.sbn-l-frame-header-products__placeholder').height()
        : $('.sbn-l-frame-header-sitemap__placeholder').height();
      if ($(target).attr('data-smoothscroll-offset') !== undefined) {
        position += parseInt($(target).attr('data-smoothscroll-offset'), 10);
      } else if (
        $(target).attr('data-smoothscroll-offset-pc') !== undefined
        && !isMobile()
      ) {
        position += parseInt($(target).attr('data-smoothscroll-offset-pc'), 10);
      } else if (
        $(target).attr('data-smoothscroll-offset-sp') !== undefined
        && isMobile()
      ) {
        position
          += parseFloat($(target).attr('data-smoothscroll-offset-sp'))
          * $('html').css('font-size');
      }
      position -= positionOffset;
      return position;
    }
    function triggerScroll(context) {
      var href = typeof context === 'string'
        ? context
        : '#' + $(context).attr('href').split('#')[1];
      // var href = typeof context === 'string'
      //   ? decodeURIComponent(context)
      //   : '#' + $(context).attr('href').split('#')[1];
      if (!$(context).hasClass('no-scroll') && $(href).length) {
        if (isWindowFrozen === true) {
          delay = 500;
          frozeWindow(false);
        }
        lightboxTogglingCloseAll();
        lightboxAnchorCloseAll();
        setTimeout(function onTimeout() {
          $('body, html').animate(
            { scrollTop: getPosition($(href)) },
            speed,
            'swing'
          );
        }, delay);
        return false;
      }
      return true;
    }
    setTimeout(function setTimerHTMLVisibility() {
      window.scroll(0, 0);
      $('html').removeClass('sbn-is-loading').addClass('sbn-is-visible');
    }, 1);
    if (window.location.hash) {
      window.scroll(0, 0);
      if (
        navigator.userAgent.indexOf('MSIE ') > -1
        || navigator.userAgent.indexOf('Trident/') > -1
      ) {
        timeout = 0;
      } else {
        timeout = 500;
      }
      setTimeout(function setTimerTriggerScroll() {
        triggerScroll(window.location.hash);
      }, timeout);
    }
    anchors.on('click', function onClickAnchor() {
      return triggerScroll(this);
    });
  }

  function sliderMobile() {
    if (!$('.sbn-js-slider-mobile').length) return;
    $('.sbn-js-slider-mobile').each(function onEach() {
      var slider = $(this);
      function init() {
        var sliderPackage = slider.find('.swiper')[0].swiper;
        if (!sliderPackage && isMobile()) {
          new Swiper(slider.find('.swiper')[0], {
            speed: 500,
            slidesPerView: 1,
            centeredSlides: true,
            effect: 'fade',
            navigation: {
              nextEl: '.swiper-arrow-next',
              prevEl: '.swiper-arrow-prev'
            }
          });
        } else if (sliderPackage && !isMobile()) {
          sliderPackage.destroy(true, true);
        }
      }
      $(window).on('resize', function onResize() {
        init();
      });
      init();
    });
  }

  function sliderKeyvisual() {
    var classRunningStart = 'sbn-is-running-start';
    var classRunningEnd = 'sbn-is-running-end';
    if (!$('.sbn-js-slider-keyvisual').length) return;
    $('.sbn-js-slider-keyvisual').each(function onEach() {
      var slider = $(this);
      var sliderMain = slider.find('[data-slider-role="main"]');
      var sliderMainProgress = slider.find(
        '[data-slider-role="main-progress"]'
      );
      var sliderThumbnail = slider.find('[data-slider-role="thumbnail"]');
      var sliderThumbnailEvent = new Swiper(sliderThumbnail[0], {
        loop: true,
        spaceBetween: 7.8,
        breakpoints: {
          768: {
            spaceBetween: 10
          }
        },
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
        speed: 500
      });
      new Swiper(sliderMain[0], {
        loop: true,
        spaceBetween: 0,
        thumbs: {
          swiper: sliderThumbnailEvent
        },
        speed: 1000,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        on: {
          transitionStart: function onTransitionStart() {
            sliderMainProgress.addClass(classRunningEnd);
            sliderMainProgress.removeClass(classRunningStart);
          },
          transitionEnd: function onTransitionEnd() {
            sliderMainProgress.addClass(classRunningStart);
            sliderMainProgress.removeClass(classRunningEnd);
          },
          autoplayStop: function onAutoplayStop() {
            sliderMainProgress.addClass(classRunningEnd);
            sliderMainProgress.removeClass(classRunningStart);
          },
          autoplayPause: function onAutoplayPause() {
            sliderMainProgress.addClass(classRunningEnd);
            sliderMainProgress.removeClass(classRunningStart);
          },
          autoplayStart: function onAutoplayStart() {
            sliderMainProgress.addClass(classRunningStart);
            sliderMainProgress.removeClass(classRunningEnd);
          },
          autoplayResume: function onAutoplayResume() {
            sliderMainProgress.addClass(classRunningStart);
            sliderMainProgress.removeClass(classRunningEnd);
          },
          autoplayTimeLeft: function onAutoplayTimeLeft(
            _slider,
            _time,
            progress
          ) {
            var progressPercent = (1 - progress) * 100;
            sliderMainProgress.css('width', progressPercent + '%');
          }
        }
      });
    });
  }

  function sliderCollection() {
    if (!$('.sbn-js-slider-collection').length) return;
    $('.sbn-js-slider-collection').each(function onEach() {
      var slider = $(this);
      var sliderViewport = slider.find('.swiper');
      var sliderArrowNext = slider.find('[data-slider-role="arrow-next"]');
      var sliderArrowPrevious = slider.find(
        '[data-slider-role="arrow-previous"]'
      );
      new Swiper(sliderViewport[0], {
        loop: false,
        spaceBetween: 0,
        slidesPerView: 'auto',
        speed: 500,
        fade: true,
        navigation: {
          nextEl: sliderArrowNext[0],
          prevEl: sliderArrowPrevious[0]
        }
      });
    });
  }

  function sliderChoice() {
    if (!$('.sbn-js-slider-choice').length) return;

    $('.sbn-js-slider-choice').each(function onEach() {
      var classReady = 'is-ready';
      var classActive = 'is-active';
      var classActiveFirst = 'is-active-first';
      var slider = $(this);
      var sliderViewport = slider.find('.swiper');
      var sliderArrowNext = slider.find('[data-slider-role="arrow-next"]');
      var sliderArrowPrevious = slider.find(
        '[data-slider-role="arrow-previous"]'
      );

      var sliderInstance = new Swiper(sliderViewport[0], {
        loop: true,
        spaceBetween: 0,
        slidesPerView: 1,
        effect: 'fade',
        speed: 500
      });

      sliderViewport
        .find('.swiper-slide')
        .eq(0)
        .addClass(classActive)
        .addClass(classActiveFirst);

      sliderInstance.on('slideChangeTransitionStart', function onStart() {
        sliderViewport
          .find('.swiper-slide')
          .removeClass(classActive)
          .removeClass(classActiveFirst);
        sliderViewport
          .find('.swiper-slide')
          .eq(sliderInstance.activeIndex)
          .addClass(classActive);
      });

      sliderArrowPrevious.on('click', function onPrev() {
        var prevIndex = sliderInstance.realIndex - 1;
        if (prevIndex < 0) {
          prevIndex = sliderInstance.slides.length - 1;
        }
        sliderInstance.slideToLoop(prevIndex, 500);
      });

      sliderArrowNext.on('click', function onNext() {
        var nextIndex = sliderInstance.realIndex + 1;
        if (nextIndex >= sliderInstance.slides.length) {
          nextIndex = 0;
        }
        sliderInstance.slideToLoop(nextIndex, 500);
      });

      setTimeout(function onTimeout() {
        slider.addClass(classReady);
      }, 500);
    });
  }

  function sliderProduct() {
    var swiper = null;
    var classCurrent = 'sbn-is-current';
    if (!$('.sbn-js-slider-product').length) return;
    swiper = new Swiper('.sbn-js-slider-product .swiper', {
      slidesPerView: 1,
      navigation: {
        nextEl: '.sbn-js-slider-product .swiper-button-next',
        prevEl: '.sbn-js-slider-product .swiper-button-prev'
      }
    });
    $('.sbn-js-slider-product-thumbnail').each(function loop(i, thumbnail) {
      $(thumbnail).on('click', function onClick() {
        swiper.slideTo(i);
        $('.sbn-js-slider-product-thumbnail').removeClass(classCurrent);
        $(thumbnail).addClass(classCurrent);
      });
    });
    swiper.on('slideChange', function onSlideChange() {
      $('.sbn-js-slider-product-thumbnail')
        .removeClass(classCurrent)
        .eq(swiper.activeIndex)
        .addClass(classCurrent);
    });
  }

  function sliderRental() {
    var slider = $('.sbn-js-slider-rental');
    var sliderWrapper = null;
    var sliderWrapperHTML = null;
    var multiply = 2;
    var i = 0;
    if (!slider.length) return;
    sliderWrapper = slider.find('.swiper-wrapper');
    sliderWrapperHTML = sliderWrapper.html();
    for (i = 0; i < multiply; i += 1) {
      sliderWrapper.append(sliderWrapperHTML);
    }
    new Swiper('.sbn-js-slider-rental', {
      loop: true,
      slidesPerView: 5,
      spaceBetween: 30,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
  }

  function sliderTemplate() {
    var classActive = 'sbn-is-active';
    if (!$('.sbn-js-slider-template').length) return;
    $('.sbn-js-slider-template').each(function onEach() {
      var slider = $(this);
      var sliderMain = slider.find('[data-slider-role="main"]');
      var sliderMainArrowNext = sliderMain.find(
        '[data-slider-role="main-arrow-next"]'
      );
      var sliderMainArrowPrevious = sliderMain.find(
        '[data-slider-role="main-arrow-previous"]'
      );
      var sliderMainFraction = sliderMain.find(
        '[data-slider-role="main-fraction"]'
      );
      var sliderNavigation = slider.find('[data-slider-role="navigation"]');
      var sliderNavigationThumbnail = sliderNavigation.find(
        '[data-slider-role="navigation-thumbnail"]'
      );
      var isPause = false;
      var sliderMainEvent = null;
      function calculatePosition(thumbnail) {
        var thumbnailPosition = thumbnail.parent().position().left;
        var thumbnailPositionOffset = (parseFloat(thumbnail.parent().css('margin-left')) || 0)
          - (parseFloat(sliderNavigation.css('padding-left')) || 0);
        thumbnailPosition = thumbnailPosition
          + thumbnailPositionOffset
          + sliderNavigation.scrollLeft();
        sliderNavigation.stop().animate(
          {
            scrollLeft: thumbnailPosition
          },
          500,
          function callback() {
            isPause = false;
          }
        );
      }
      sliderMainEvent = new Swiper(sliderMain[0], {
        loop: false,
        spaceBetween: 0,
        speed: 500,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        navigation: {
          nextEl: sliderMainArrowNext[0],
          prevEl: sliderMainArrowPrevious[0]
        },
        pagination: {
          el: sliderMainFraction[0],
          type: 'fraction'
        },
        on: {
          slideChange: function onSlideChange(swiper) {
            sliderNavigationThumbnail.removeClass(classActive);
            sliderNavigationThumbnail
              .eq(swiper.realIndex)
              .addClass(classActive);
            calculatePosition(sliderNavigationThumbnail.eq(swiper.realIndex));
          }
        }
      });
      sliderNavigationThumbnail.on('click', function onClick() {
        var thumbnail = null;
        var thumbnailIndex = null;
        if (!isPause) {
          thumbnail = $(this);
          thumbnailIndex = sliderNavigationThumbnail.index(thumbnail);
          isPause = true;
          sliderMainEvent.slideToLoop(thumbnailIndex);
          sliderNavigationThumbnail.removeClass(classActive);
          thumbnail.addClass(classActive);
          calculatePosition(thumbnail);
        }
      });
      sliderNavigationThumbnail.eq(0).addClass(classActive);
    });
  }

  function sliderFlexible() {
    var classActive = 'sbn-is-active';
    var classDisabled = 'sbn-is-disabled';
    if (!$('.sbn-js-slider-flexible').length) return;
    $('.sbn-js-slider-flexible').each(function onEach() {
      var i = 0;
      var slider = $(this);
      var sliderViewport = slider.find('.swiper');
      var sliderTotal = sliderViewport.find('.swiper-slide').length;
      var sliderArrowNext = slider.find('[data-slider-role="arrow-next"]');
      var sliderArrowPrevious = slider.find(
        '[data-slider-role="arrow-previous"]'
      );
      var sliderPagination = slider.find('[data-slider-role="pagination"]');
      var sliderSettingsLoop = slider.attr('data-slider-loop') === 'true';
      var sliderSettingsViewPC = slider.attr('data-slider-view-pc') !== undefined
        ? parseFloat(slider.attr('data-slider-view-pc'))
        : 1;
      var sliderSettingsViewSP = slider.attr('data-slider-view-sp') !== undefined
        ? parseFloat(slider.attr('data-slider-view-sp'))
        : 1;
      var sliderSettings = null;
      var sliderInstance = null;

      function initLayout() {
        var dot = null;
        if (sliderPagination.length) {
          sliderPagination.empty();
          for (i = 0; i < sliderTotal; i += 1) {
            dot = $('<span class="sbn-c-dot"></span>');
            dot.attr('data-slider-index', i);
            sliderPagination.append(dot);
          }
          sliderPagination.find('.sbn-c-dot').on('click', function onClick() {
            var index = $(this).data('slider-index');
            sliderInstance.slideTo(index);
          });
          sliderPagination.find('.sbn-c-dot').eq(0).addClass(classActive);
        }
        if (!sliderSettingsLoop && sliderArrowPrevious.length) {
          sliderArrowPrevious.addClass(classDisabled);
        }
      }
      function updateLayout() {
        if (sliderPagination.length) {
          sliderPagination.find('.sbn-c-dot').removeClass(classActive);
          sliderPagination
            .find('.sbn-c-dot')
            .eq(sliderInstance.realIndex)
            .addClass(classActive);
        }
        if (
          !sliderSettingsLoop
          && sliderArrowPrevious.length
          && sliderArrowPrevious.length
        ) {
          if (sliderInstance.isEnd) {
            sliderArrowNext.addClass(classDisabled);
          } else {
            sliderArrowNext.removeClass(classDisabled);
          }
          if (sliderInstance.isBeginning) {
            sliderArrowPrevious.addClass(classDisabled);
          } else {
            sliderArrowPrevious.removeClass(classDisabled);
          }
        }
      }

      sliderSettings = {
        loop: sliderSettingsLoop,
        spaceBetween: 0,
        speed: 500,
        slidesPerView: sliderSettingsViewSP,
        on: {
          init: initLayout,
          slideChange: updateLayout
        },
        breakpoints: {
          768: {
            slidesPerView: sliderSettingsViewPC
          }
        }
      };
      if (sliderSettingsLoop) {
        sliderSettings.on.reachEnd = updateLayout;
        sliderSettings.on.reachBeginning = updateLayout;
      }
      sliderInstance = new Swiper(sliderViewport[0], sliderSettings);
      if (sliderArrowPrevious.length && sliderArrowPrevious.length) {
        sliderArrowNext.on('click', function onClick() {
          sliderInstance.slideNext();
        });
        sliderArrowPrevious.on('click', function onClick() {
          sliderInstance.slidePrev();
        });
      }
    });
  }

  function sliderHokkaido() {
    if (!$('.sbn-js-slider-hokkaido').length) return;
    new Swiper('.sbn-js-slider-hokkaido', {
      loop: true,
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
  }

  function tabsDefault() {
    var classCurrent = 'sbn-is-current';
    function setHighlighter(tabsHighlighter, target) {
      var tabsIDGroup = $(tabsHighlighter).attr('data-tabs-id-group');
      var tabsToggleCurrent = $(target).length
        ? $(target)
        : $(
          '.sbn-js-tabs-default'
              + '.'
              + classCurrent
              + '[data-tabs-role="toggle"][data-tabs-id-group="'
              + tabsIDGroup
              + '"]'
        );
      if ($(tabsHighlighter).length) {
        $(tabsHighlighter).css({
          width: tabsToggleCurrent.width(),
          left: tabsToggleCurrent.position().left
        });
      }
    }
    if (!$('.sbn-js-tabs-default').length) return;
    $('.sbn-js-tabs-default[data-tabs-role="toggle"]').each(function onEach() {
      var tabsToggle = $(this);
      var tabsIDGroup = tabsToggle.attr('data-tabs-id-group');
      var tabsToggleGroup = $(
        '.sbn-js-tabs-default[data-tabs-role="toggle"][data-tabs-id-group="'
          + tabsIDGroup
          + '"]'
      );
      var tabsIDLocal = tabsToggle.attr('data-tabs-id-local').split(/\s+/);
      var tabsTargetGroup = $(
        '.sbn-js-tabs-default[data-tabs-role="target"][data-tabs-id-group="'
          + tabsIDGroup
          + '"]'
      );
      var tabsParentGroup = $(
        '.sbn-js-tabs-default[data-tabs-role="parent"][data-tabs-id-group="'
          + tabsIDGroup
          + '"]'
      );
      var tabsTargetBundle = [];
      var tabsHighlighter = $(
        '.sbn-js-tabs-default[data-tabs-role="highlighter"][data-tabs-id-group="'
          + tabsIDGroup
          + '"]'
      );
      tabsTargetGroup.each(function onEachTargetGroup() {
        var target = $(this);
        var targetID = target.attr('data-tabs-id-local').split(/\s+/);
        var isMatched = tabsIDLocal.some(function onSome(toggleID) {
          return targetID.includes(toggleID);
        });
        if (isMatched) {
          tabsTargetBundle.push(target);
        }
      });
      tabsToggle.on('click', function onClick() {
        tabsToggleGroup.removeClass(classCurrent);
        tabsTargetGroup.removeClass(classCurrent);
        tabsToggle.addClass(classCurrent);
        $(tabsTargetBundle).each(function onEachTargetBundle() {
          $(this).addClass(classCurrent);
        });
        if (tabsParentGroup) {
          $(tabsParentGroup).attr(
            'data-tabs-index',
            tabsToggle.attr('data-tabs-id-local')
          );
        }
        setHighlighter(tabsHighlighter);
      });
    });
    $('.sbn-js-tabs-default[data-tabs-role="highlighter"]').each(
      function onEach() {
        var tabsHighlighter = this;
        $(window).on('load resize', function onResize() {
          setHighlighter(tabsHighlighter);
        });
      }
    );
  }

  function navigationFixed() {
    var classVisible = 'sbn-is-visible';
    var navigation = $('.sbn-js-navigation-fixed');
    var header = $('header');
    if (!navigation.length) return;
    $(window).on('load scroll resize', function onLoad() {
      var scrollPositionTop = $(window).scrollTop();
      var limitEnd = header.height() * 3;
      if (scrollPositionTop > limitEnd) {
        navigation.addClass(classVisible);
      } else {
        navigation.removeClass(classVisible);
      }
    });
  }

  function lightboxAnchorGet(
    lightboxToggle,
    lightboxToggleIDGroup,
    lightboxToggleIDLocal
  ) {
    var result = {};
    result.lightboxToggleLocal = lightboxToggle;
    result.lightboxToggleGroup = $(
      '.sbn-js-lightbox-anchor[data-lightbox-role="toggle"][data-lightbox-id-group="'
        + lightboxToggleIDGroup
        + '"]'
    );
    result.lightboxToggleGlobal = $(
      '.sbn-js-lightbox-anchor[data-lightbox-role="toggle"]'
    );
    result.lightboxTargetGroup = $(
      '.sbn-js-lightbox-anchor[data-lightbox-role="target"][data-lightbox-id-group="'
        + lightboxToggleIDGroup
        + '"]'
    );
    result.lightboxTargetGlobal = $(
      '.sbn-js-lightbox-anchor[data-lightbox-role="target"]'
    );
    result.lightboxParentGlobal = $(
      '.sbn-js-lightbox-anchor[data-lightbox-role="parent"]'
    );
    result.lightboxToggleBundle = [];
    result.lightboxTargetBundle = [];
    result.lightboxParentBundle = [];
    result.lightboxToggleGroup.each(function onEachToggleGroup() {
      var toggle = $(this);
      var toggleID1 = toggle.attr('data-lightbox-id-local').split(/\s+/);
      var isMatched = lightboxToggleIDLocal.some(function onSome(toggleID2) {
        return toggleID1.includes(toggleID2);
      });
      if (isMatched) {
        result.lightboxToggleBundle.push(toggle);
      }
    });
    result.lightboxTargetGroup.each(function onEachTargetGroup() {
      var target = $(this);
      var targetID = target.attr('data-lightbox-id-local').split(/\s+/);
      var isMatched = lightboxToggleIDLocal.some(function onSome(toggleID) {
        return targetID.includes(toggleID);
      });
      if (isMatched) {
        result.lightboxTargetBundle.push(target);
      }
    });
    result.lightboxParentGlobal.each(function onEachParentGlobal() {
      var parent = $(this);
      var parentID = parent.attr('data-lightbox-id-local').split(/\s+/);
      var isMatched = parentID.includes(lightboxToggleIDGroup);
      if (isMatched) {
        result.lightboxParentBundle.push(parent);
      }
    });
    return result;
  }

  function lightboxAnchorOpen(lightboxSettings) {
    var classReady = 'sbn-is-ready';
    var classActive = 'sbn-is-active';
    var classGlobalActive = 'sbn-is-lightbox-active';
    $('html').addClass(classGlobalActive);
    $(lightboxSettings.lightboxToggleGroup)
      .addClass(classReady)
      .removeClass(classActive);
    $(lightboxSettings.lightboxTargetGroup)
      .addClass(classReady)
      .removeClass(classActive);
    $(lightboxSettings.lightboxParentGlobal)
      .addClass(classReady)
      .removeClass(classActive);
    $(lightboxSettings.lightboxToggleLocal)
      .addClass(classReady)
      .addClass(classActive);
    $(lightboxSettings.lightboxTargetBundle).each(
      function onEachTargetBundle() {
        $(this).addClass(classReady).addClass(classActive);
      }
    );
    $(lightboxSettings.lightboxParentBundle).each(
      function onEachParentBundle() {
        $(this).addClass(classReady).addClass(classActive);
      }
    );
    if (!isWindowFrozen) {
      if (lightboxSettings.lightboxTargetBundle.length > 0) {
        frozeWindow(true, $(lightboxSettings.lightboxTargetBundle[0]));
      } else {
        frozeWindow(true, $(''));
      }
    } else if (lightboxSettings.lightboxTargetBundle.length > 0) {
      frozeException = $(lightboxSettings.lightboxTargetBundle[0]);
    }
  }

  function lightboxAnchor() {
    var classReady = 'sbn-is-ready';
    var classGlobalActive = 'sbn-is-lightbox-active';
    var classActive = 'sbn-is-active';
    if (!$('.sbn-js-lightbox-anchor').length) return;
    $('.sbn-js-lightbox-anchor[data-lightbox-role="toggle"]').each(
      function onEach() {
        var lightboxToggle = $(this);
        var lightboxToggleSettings = lightboxToggle.attr(
          'data-lightbox-settings'
        );
        var lightboxToggleIDGroup = lightboxToggle.attr(
          'data-lightbox-id-group'
        );
        var lightboxToggleIDLocal = lightboxToggle
          .attr('data-lightbox-id-local')
          .split(/\s+/);
        var lightboxSettings = lightboxAnchorGet(
          lightboxToggle,
          lightboxToggleIDGroup,
          lightboxToggleIDLocal
        );
        lightboxToggle.on('click', function onClick() {
          if (
            !isMobile()
            && !isTouchable()
            && (lightboxToggleIDGroup === 'series-girl' || lightboxToggleIDGroup === 'series-boy' || lightboxToggleIDGroup === 'series-all')
            && !lightboxToggle.hasClass(classActive)
          ) {
            lightboxAnchorOpen(lightboxSettings);
            return false;
          }
          if (lightboxToggleSettings === 'pc-only') {
            if (
              !isMobile()
              && isTouchable()
              && !lightboxToggle.hasClass(classActive)
            ) {
              lightboxAnchorOpen(lightboxSettings);
              return false;
            }
          } else if (lightboxToggleSettings === 'sp-only') {
            if (isMobile() && !lightboxToggle.hasClass(classActive)) {
              lightboxAnchorOpen(lightboxSettings);
              return false;
            }
          } else if (
            (isMobile() || isTouchable())
            && !lightboxToggle.hasClass(classActive)
          ) {
            lightboxAnchorOpen(lightboxSettings);
            return false;
          }
          return true;
        });
        lightboxToggle.on('mouseover', function onHover() {
          if (
            !isMobile()
            && !isTouchable()
            && lightboxToggleSettings !== 'sp-only'
            && lightboxToggleIDGroup !== 'series-girl'
            && lightboxToggleIDGroup !== 'series-boy'
            && lightboxToggleIDGroup !== 'series-all'
          ) {
            lightboxAnchorOpen(lightboxSettings);
          }
        });
      }
    );
    $('.sbn-js-lightbox-anchor[data-lightbox-role="toggle-close"]').on(
      'click',
      function onClick() {
        lightboxAnchorCloseAll();
        lightboxTogglingCloseAll();
      }
    );
    $('.sbn-js-lightbox-anchor[data-lightbox-role="mask"]').on(
      'click mouseover',
      function onHover() {
        lightboxAnchorCloseAll();
        lightboxTogglingCloseAll();
      }
    );
    $(document).on('mouseover', function onHover(event) {
      var isGlobalActive;
      var isActive;
      var isOutToggle;
      var isOutTarget;
      isGlobalActive = $('html').hasClass(classGlobalActive);
      isActive = $(
        '.sbn-js-lightbox-anchor[data-lightbox-role="target"]'
      ).hasClass(classActive);
      if (!isMobile() && isGlobalActive && isActive) {
        isOutToggle = isOutside(
          event,
          $('.sbn-js-lightbox-anchor[data-lightbox-role="toggle"]').parent()
        );
        isOutTarget = isOutside(
          event,
          $('.sbn-js-lightbox-anchor[data-lightbox-role="target"]')
        );
        if (isOutToggle && isOutTarget) {
          lightboxAnchorCloseAll();
        }
      }
    });
    $(window).on('resize', function onResize() {
      $('.sbn-js-lightbox-anchor').removeClass(classReady);
    });
  }

  function lightboxTogglingGet(lightboxToggleID) {
    var result = {};
    result.lightboxToggle = $(
      '.sbn-js-lightbox-toggling[data-lightbox-role="toggle"][data-lightbox-id="'
        + lightboxToggleID
        + '"]'
    );
    result.lightboxTarget = $(
      '.sbn-js-lightbox-toggling[data-lightbox-role="target"][data-lightbox-id="'
        + lightboxToggleID
        + '"]'
    );
    return result;
  }

  function lightboxTogglingOpen(lightboxSettings) {
    var classReady = 'sbn-is-ready';
    var classActive = 'sbn-is-active';
    var classGlobalActive = 'sbn-is-lightbox-active';
    $('html').addClass(classGlobalActive);
    $(lightboxSettings.lightboxToggle)
      .addClass(classReady)
      .addClass(classActive);
    $(lightboxSettings.lightboxTarget)
      .addClass(classReady)
      .addClass(classActive);
    if (!isWindowFrozen) {
      frozeWindow(true, $(lightboxSettings.lightboxTarget));
    } else {
      frozeException = $(lightboxSettings.lightboxTarget);
    }
  }

  function lightboxToggling() {
    var classActive = 'sbn-is-active';
    var classReady = 'sbn-is-ready';
    if (!$('.sbn-js-lightbox-toggling').length) return;
    $('.sbn-js-lightbox-toggling[data-lightbox-role="toggle"]').each(
      function onEach() {
        var lightboxToggle = $(this);
        var lightboxToggleID = lightboxToggle.attr('data-lightbox-id');
        var lightboxSettings = lightboxTogglingGet(lightboxToggleID);
        lightboxToggle.on('click', function onClick() {
          if (!lightboxToggle.hasClass(classActive)) {
            lightboxTogglingOpen(lightboxSettings);
          } else {
            lightboxTogglingCloseAll();
          }
        });
      }
    );
    $('.sbn-js-lightbox-toggling[data-lightbox-role="toggle-back"]').on(
      'click',
      function onHover() {
        var lightboxToggle = $(this);
        var lightboxToggleID = lightboxToggle.attr('data-lightbox-id');
        var lightboxSettings = lightboxTogglingGet(lightboxToggleID);
        lightboxAnchorCloseAll();
        lightboxTogglingOpen(lightboxSettings);
      }
    );
    $('.sbn-js-lightbox-toggling[data-lightbox-role="toggle-close"]').on(
      'click',
      function onHover() {
        lightboxTogglingCloseAll();
        lightboxAnchorCloseAll();
      }
    );
    $(window).on('resize', function onResize() {
      $('.sbn-js-lightbox-toggling').removeClass(classReady);
    });
  }

  function selectMap() {
    var selectButton = $('.sbn-c-map-address__search-item');
    var selectContent = $('.sbn-c-map-address__search-address');
    var currentContent = null;

    selectButton.on('click', function onClickSelectButton(e) {
      e.stopPropagation();

      currentContent = $(this).find(selectContent);

      if (currentContent.hasClass('sbn-is-active')) {
        currentContent.removeClass('sbn-is-active');
      } else {
        selectContent.removeClass('sbn-is-active');
        currentContent.addClass('sbn-is-active');
      }
    });

    $(document).on('click', function onClickDocument() {
      selectContent.removeClass('sbn-is-active');
    });
  }

  function buttonTop() {
    var buttonToTop = $('.sbn-js-button-to-top');
    if ($('.sbn-js-button-to-top').length) {
      buttonToTop.click(function onClickButtonToTop() {
        $('html, body').animate(
          {
            scrollTop: 0
          },
          500
        );
        return false;
      });
    }
  }

  function tabsStore() {
    var classCurrent = 'sbn-current';
    if (!$('.sbn-js-tabs-store-container')) return;
    $('.sbn-js-tabs-store').each(function tabSocial() {
      $(this)
        .find('li')
        .click(function onClickTab() {
          var tabContent = $(this).attr('data-tab');
          var sectionCurrent = $(this).closest('.sbn-js-tabs-store-container');
          var tabStoreCurrent = sectionCurrent.find('.sbn-js-tab-store');
          var tabPositionOffset = !isMobile()
            ? $('.sbn-l-frame-header-products__placeholder').height()
            : $('.sbn-l-frame-header-sitemap__placeholder').height();
          var isScrollable = $(this).attr('data-tab-scrollable') === 'true';
          sectionCurrent
            .find('.sbn-js-tabs-store li')
            .removeClass(classCurrent);
          tabStoreCurrent.find('.sbn-tab-content').removeClass(classCurrent);
          sectionCurrent
            .find('li[data-tab="' + tabContent + '"]')
            .addClass(classCurrent);
          tabStoreCurrent.find('#' + tabContent).addClass(classCurrent);
          if (isScrollable) {
            $('body, html').animate(
              {
                scrollTop: sectionCurrent.eq(0).offset().top - tabPositionOffset
              },
              500,
              'swing'
            );
          }
        });
    });
  }

  function tabsService() {
    var classCurrent = 'sbn-active';
    if (!$('.sbn-js-tabs-service-container')) return;
    $('.sbn-js-tabs-service').each(function tabSocial() {
      $(this)
        .find('li')
        .click(function onClickTab() {
          var tabContent = $(this).attr('data-tab');
          var sectionCurrent = $(this).closest(
            '.sbn-js-tabs-service-container'
          );
          var tabServiceCurrent = sectionCurrent.find('.sbn-js-tab-service');
          var tabPositionOffset = !isMobile()
            ? $('.sbn-l-frame-header-products__placeholder').height()
            : $('.sbn-l-frame-header-sitemap__placeholder').height();
          var isScrollable = $(this).attr('data-tab-scrollable') === 'true';
          sectionCurrent
            .find('.sbn-js-tabs-service li')
            .removeClass(classCurrent);
          tabServiceCurrent.find('.sbn-tab-content').removeClass(classCurrent);
          sectionCurrent
            .find('li[data-tab="' + tabContent + '"]')
            .addClass(classCurrent);
          tabServiceCurrent.find('#' + tabContent).addClass(classCurrent);
          if (isScrollable) {
            $('body, html').animate(
              {
                scrollTop: sectionCurrent.eq(0).offset().top - tabPositionOffset
              },
              500,
              'swing'
            );
          }
        });
    });
  }

  function modalImageZoom() {
    var lightbox = $('.sbn-js-lightbox-popup');
    var buttonOpen = $('.sbn-js-open-lightbox');
    var currentImage = null;
    var panZoomWrapper = $('.sbn-js-panzoom-wrapper');
    var minScale = 1;
    var maxScale = 2;
    var panZoom = null;
    if (!lightbox.length) return;

    panZoom = Panzoom(panZoomWrapper.find('.sbn-js-panzoom')[0], {
      startScale: minScale,
      minScale: minScale,
      maxScale: maxScale
    });

    buttonOpen.on('click', function onClick() {
      currentImage = $('.sbn-js-lightbox-image').find(
        'img[data-image="' + $(this).attr('data-image') + '"]'
      );
      lightbox.find('.sbn-js-panzoom').append(currentImage);
      lightbox.fadeIn('fast', function onComplete() {
        pageOffsetY = window.scrollY;
        $('body').css({
          position: 'fixed',
          top: -pageOffsetY + 'px',
          width: '100%',
          overflowY: 'auto'
        });
      });

      panZoom.reset({ animate: false });
      setTimeout(function timer() {
        panZoom.zoom(maxScale, {
          animate: true,
          duration: 600
        });
      }, 100);
    });

    lightbox
      .find('.sbn-js-popup-close, .sbn-js-popup-overlay')
      .on('click', function onClick() {
        $('body').removeAttr('style');
        $(window).scrollTop(pageOffsetY);
        lightbox.fadeOut('fast', function onComplete() {
          $('.sbn-js-lightbox-image').append(currentImage);
          currentImage = null;
        });
      });

    panZoomWrapper.on('wheel', function onWheel(e) {
      var zoomLevel = e.originalEvent.wheelDelta / 1000;
      if (zoomLevel > 0) {
        panZoom.zoomIn(zoomLevel);
      } else {
        panZoom.zoomOut(zoomLevel);
      }
    });
  }

  function sliderGalleryRemake() {
    var detectSlider = window.innerWidth <= 767.98;
    if (!$('.js-slider-gallery-remake').length) return;
    $('.js-slider-gallery-remake').each(function initSlider() {
      var slider = $(this);
      var sliderPackage = slider.find('.swiper')[0].swiper;

      if (!sliderPackage && detectSlider) {
        new Swiper(slider.find('.swiper')[0], {
          speed: 500,
          slidesPerView: 'auto',
          loop: true,
          spaceBetween: 40,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        });
      } else if (sliderPackage && !detectSlider) {
        sliderPackage.destroy(true, true);
      }
    });
  }

  function sliderBlog() {
    var slider = $('.sbn-js-slider-bloghiroba');
    var sliderWrapper = null;
    var sliderWrapperHTML = null;
    var multiply = 2;
    var i = 0;
    if (!slider.length) return;
    sliderWrapper = slider.find('.swiper-wrapper');
    sliderWrapperHTML = sliderWrapper.html();
    for (i = 0; i < multiply; i += 1) {
      sliderWrapper.append(sliderWrapperHTML);
    }
    new Swiper('.sbn-js-slider-bloghiroba', {
      loop: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 60,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
  }

  function closeBoxContent() {
    var buttonBoxClose = $('.sbn-js-box-close');
    var boxContent = $('.sbn-js-box-content');
    buttonBoxClose.on('click', function onClickCloseBox() {
      $(this).closest(boxContent).hide();
    });
  }

  function sliderGalleryMulTiPouch() {
    var detectSlider = window.innerWidth <= 767.98;
    if (!$('.js-slider-gallery-multipouch').length) return;
    $('.js-slider-gallery-multipouch').each(function initSlider() {
      var slider = $(this);
      var sliderPackage = slider.find('.swiper')[0].swiper;

      if (!sliderPackage && detectSlider) {
        new Swiper(slider.find('.swiper')[0], {
          speed: 500,
          slidesPerView: 'auto',
          loop: true,
          spaceBetween: 40,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        });
      } else if (sliderPackage && !detectSlider) {
        sliderPackage.destroy(true, true);
      }
    });
  }

  function customSelectBox() {
    var customSelect = $('.sbn-js-custom-select');
    if (!$('.sbn-js-custom-select').length) return;

    customSelect.each(function customSelectItem() {
      var currentSelect = $(this);
      var selectedItems = $(
        '<div class="sbn-c-select-searching__select-list option-first sbn-js-select-selected"></div>'
      );
      var selectItems = $(
        '<div class="sbn-c-select-searching__select-item sbn-select-hide sbn-js-select-items"></div>'
      );
      selectedItems.html(currentSelect.find('select option:first').html());
      currentSelect.append(selectedItems);
      currentSelect
        .find('select option:not([disabled])')
        .each(function currentSelectItem(index, option) {
          selectItems.append(
            '<div class="sbn-select-option">' + $(option).html() + '</div>'
          );
        });
      selectItems.find('div').on('click', function selectOption(e) {
        var value = $(this).html();
        $(e.currentTarget)
          .parents('.sbn-js-custom-select')
          .find('.sbn-c-select-searching__select-list')
          .addClass('sbn-is-selected');
        selectedItems.html(value);
        currentSelect.find('select option').each(function currentOption() {
          if ($(this).html() === value) {
            currentSelect.find('select').val($(this).val());
          }
        });

        const index = $(this).index();
        const select = document.getElementById('SortBy');
        const selectOptions = document.getElementById('SortBy').querySelectorAll('option');
        selectOptions[index].selected = true;

        const event = new Event('change');
        select.dispatchEvent(event);

        //// 「在庫あり/なし」の被り対処 
        const availabilitySelectElms = document.querySelectorAll('[name="filter.v.availability"]');
        const checkedItems = Array.from(availabilitySelectElms).filter(el => el.checked);
        // 在庫あり/なし選択項目が2つ以上チェックされていたら最初以外を解除
        if (checkedItems.length > 1) {
          checkedItems.forEach((el, i) => {
            if (i > 0) {
              el.checked = false;
            }
          });
        }

        const form = document.getElementById('FacetFiltersForm');
        form.submit();

      });
      currentSelect.append(selectItems);

      selectedItems.on('click', function onClickOption(e) {
        e.stopPropagation();
        selectItems.toggleClass('sbn-select-hide');
        currentSelect
          .find('.sbn-c-select-searching__select-list')
          .toggleClass('is-active');
      });
    });

    const selectedIndex = document.getElementById('SortBy').selectedIndex;
    const selectedSortValue = document.querySelector('.sbn-c-select-searching__select-list');
    const sortValues = document.querySelector('.sbn-c-select-searching__select-item');
    selectedSortValue.innerText = sortValues.querySelectorAll('.sbn-select-option')[selectedIndex].innerText.trim();

    function closeAllSelect() {
      var items = $('.sbn-c-select-searching__select-item');

      items.each(function closeSelect() {
        $(this).addClass('sbn-select-hide');
        $('.sbn-c-select-searching__select-list').removeClass('is-active');
      });
    }
    document.addEventListener('click', closeAllSelect);
  }

  function accordionFAQ() {
    $('.sbn-js-accordion-faq')
      .find('.sbn-js-accordion-faq-heading')
      .on('click', function onClickHeading() {
        $(this).parent().stop().toggleClass('sbn-is-open');
        $(this)
          .parent()
          .find('.sbn-js-accordion-faq-content')
          .stop()
          .eq(0)
          .slideToggle(500);
      });
  }

  function tabsMenuSearch(isReset) {
    var controller = $('.sbn-js-tabs-menu-search');
    var content = $(
      '.sbn-js-tabs-menu-search-content .sbn-l-navigation-search-menu__tab-content'
    );
    var buttonBack = $('.sbn-js-tabs-menu-search-back');
    if (!controller.length) return;

    function reset() {
      controller.show();
      content.removeClass('sbn-current');
      buttonBack.removeClass('sbn-is-active');
    }

    if (isReset) {
      reset();
    } else {
      controller.find('li').on('click', function onClick() {
        var tab = $(this).attr('data-tab');
        controller.hide();
        content.removeClass('sbn-current');
        $('#' + tab).addClass('sbn-current');
        buttonBack.addClass('sbn-is-active');
      });
      buttonBack.on('click', reset);
    }
  }

  function openMenu() {
    offsetY = window.pageYOffset;
    $('body').css({
      top: -offsetY + 'px'
    });
    $('body').addClass('sbn-has-menu');
    $('.sbn-js-navigation').addClass('sbn-is-show');
    menuOpen = true;
  }

  function closeMenu() {
    $('body').css({
      top: 'auto'
    });
    $('body').removeClass('sbn-has-menu');
    $(window).scrollTop(offsetY);
    $('.sbn-js-navigation')
      .stop()
      .fadeOut(400, function onComplete() {
        tabsMenuSearch(true);
      });
    $('.sbn-js-navigation').removeClass('sbn-is-show');
    menuOpen = false;
  }

  function navigationMenuSearch() {
    if (menuOpen) return;

    $('.sbn-js-button-menu').click(function onCLickOpen() {
      $(this).toggleClass('sbn-is-active');
      if ($(this).hasClass('sbn-is-active')) {
        openMenu();
      } else {
        closeMenu();
      }
      return false;
    });

    $('.js-button-close-menu').click(function onCLickClose() {
      closeMenu();
      $('.sbn-js-button-menu').removeClass('sbn-is-active');
    });

    $('.sbn-js-overlay-menu').click(function onClickOverlay() {
      closeMenu();
      $('.sbn-js-button-menu').removeClass('sbn-is-active');
      return false;
    });

    function heightNavigation() {
      var heightWindow = $(window).innerHeight();
      if ($('.sbn-js-navigation').length) {
        $('.sbn-js-navigation').css({
          height: heightWindow
        });
      }
    }

    heightNavigation();
    $(window).on('load resize', function resizeNavigation() {
      heightNavigation();
    });
  }

  function buttonMore() {
    var showList = $('.sbn-js-show-list');
    var buttonLoadMore = $('.sbn-js-button-load-more');
    var contentMore = $('.sbn-js-content-more');

    showList.each(function init() {
      var items = $(this).find('.sbn-c-list-product-results__item');
      var initialItems = parseInt($(this).attr('data-initial'), 10) || 0;

      items.hide().slice(0, initialItems).css('display', 'block');

      if (items.filter(':hidden').length === 0) {
        contentMore.hide();
      }
    });

    buttonLoadMore.on('click', function onClick() {
      var step = parseInt($(this).data('step'), 10) || 5;
      var items = $('.sbn-c-list-product-results__item');
      var hiddenItems = items.filter(':hidden');

      hiddenItems.slice(0, step).css('display', 'block');

      if (hiddenItems.length <= step) {
        contentMore.hide();
      }
    });
  }

  function sliderProductOption() {
    var classCurrent = 'sbn-is-current';
    if (!$('.sbn-js-slider-product-option').length) return;
    $('.sbn-js-slider-product-option').each(
      function initialSlider(index, sliderContainer) {
        var $sliderContainer = $(sliderContainer);
        var swiper = new Swiper($sliderContainer.find('.swiper')[0], {
          slidesPerView: 1,
          loop: true,
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          navigation: {
            nextEl: $sliderContainer.find('.swiper-button-next')[0],
            prevEl: $sliderContainer.find('.swiper-button-prev')[0]
          }
        });

        $sliderContainer
          .find('.sbn-js-slider-product-option-thumbnail')
          .each(function thumbnailSlider(i, thumbnail) {
            $(thumbnail).on('click', function onClick() {
              swiper.slideToLoop(i);
              $sliderContainer
                .find('.sbn-js-slider-product-option-thumbnail')
                .removeClass(classCurrent);
              $(thumbnail).addClass(classCurrent);
            });
          });

        swiper.on('slideChange', function onChangeSlider() {
          var realIndex = swiper.realIndex;
          $sliderContainer
            .find('.sbn-js-slider-product-option-thumbnail')
            .removeClass(classCurrent)
            .eq(realIndex)
            .addClass(classCurrent);
        });
      }
    );
  }

  $(window).on('load scroll resize', function onLoad() {
    pageOffsetX = $(window).scrollLeft();
    if (isWindowFrozen === true) {
      scrollFix($('body'));
    }
  });

  $(window).on('load resize', function onResizeWindow() {
    sliderMobile();
    sliderGalleryMulTiPouch();
    sliderGalleryRemake();
  });

  window.WebFontConfig = {
    custom: {
      families: [
        'Noto Sans:n4,n5,n6,n7',
        'Noto Sans JP:n3,n4,n5,n6,n7,n8,n9',
        'Zen Kaku Gothic New:n7',
        'Lato:n7',
        'Josefin Sans:n7'
      ],
      urls: [
        'https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;500;600;700&family=Noto+Sans+JP:wght@300;400;500;600;700;800;900&family=Zen+Kaku+Gothic+New:wght@700&family=Lato:wght@700&family=Josefin+Sans:wght@700&display=swap'
      ]
    }
  };
  (function loadFont() {
    var wf = document.createElement('script');
    var s;
    wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
    wf.type = 'text/javascript';
    wf.async = 'true';
    s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(wf, s);
  }());

  $(function init() {
    detectBrowser();
    detectDevice();
    headerCommon();
    accordionAnchor();
    accordionExpand();
    accordionRelate();
    accordionFooter();
    accordionDefault();
    scrollbarSync();
    scrollLeft();
    smoothScroll();
    sliderMobile();
    sliderKeyvisual();
    sliderCollection();
    sliderChoice();
    sliderProduct();
    sliderRental();
    sliderTemplate();
    sliderFlexible();
    sliderHokkaido();
    tabsDefault();
    lightboxAnchor();
    lightboxToggling();
    navigationFixed();
    selecting();
    tabsStore();
    tabsService();
    selectMap();
    buttonTop();
    modalImageZoom();
    prefectureSelect();
    sliderGalleryRemake();
    sliderBlog();
    closeBoxContent();
    sliderGalleryMulTiPouch();
    customSelectBox();
    accordionFAQ();
    tabsMenuSearch();
    navigationMenuSearch();
    buttonMore();
    sliderProductOption();
  });
}(jQuery));
